import { createStore } from 'utils/state'
import { STORE_KEY } from './constants'

export const initialState = {
  table: {
    items: null,
    metadata: null
  },
  filters: null,
  aggregFilter: null,
  selection: {
    selectAll: false,
    excluded: {},
    included: {},
    count: 0,
    total: 0
  }
}

export const store = createStore(initialState, STORE_KEY)
export default { [STORE_KEY]: store }

export const reducers = {
  detailTable: (updatedData, prevState) => ({
    ...prevState,
    table: {
      ...prevState.table,
      items: updatedData.items,
      metadata: updatedData.metadata
    },
    selection: {
      ...prevState.selection,
      total: updatedData.metadata.pagination.total
    }
  }),
  onChangeSelectAll: (updatedData, prevState) => ({
    ...prevState,
    selection: {
      ...prevState.selection,
      ...updatedData
    }
  }),
  onRowSelection: (updatedData, prevState) => ({
    ...prevState,
    selection: {
      ...prevState.selection,
      ...updatedData
    }
  })
}

export const selectors = {
  selection: (state) => state?.selection,
  filters: (state) => state?.filters
}
